import React from 'react';

import {ProcessClientOrigin} from 'graphql-client/__generated/graphqlGlobalTypes';
import {NO_ACCESS_TEXT} from 'processes/ProcessConstants';
import {ChipSize} from 'ui-library/chips/Chip';
import {ChipPopoverInfoField} from 'ui-library/chips/ChipPopoverContent';
import ProcessTaskChip from 'ui-library/chips/ProcessTaskChip';

import {GetChipPopoverContentsArgs} from '../ChipUtilConstants';
import {getProcedureChipPopoverFields, getProcedureTemplateField} from '../procedures/getCommonFields';
import getProcedureUnitOperationChipPopoverContents, {
  extractMethodExecutionInfo,
} from '../procedures/getProcedureUnitOperationChipPopoverContents';

export default function getRecipeUnitOperationChipPopoverContents({
  processTask,
  icon,
}: GetChipPopoverContentsArgs): Array<ChipPopoverInfoField> {
  const methodExecutionInstance = processTask.procedureMethodExecutionInstance;
  const {conditionReplicateRunTaskId, procedureRun} = extractMethodExecutionInfo(methodExecutionInstance);

  return getProcedureUnitOperationChipPopoverContents({
    processTask,
    icon,
    runPopoverField: {
      label: getProcedureChipPopoverFields().RECIPE_CONDITION_REPLICATE_RUN,
      value:
        conditionReplicateRunTaskId != null ? (
          <ProcessTaskChip id={conditionReplicateRunTaskId} size={ChipSize.MINI} />
        ) : (
          NO_ACCESS_TEXT
        ),
    },
    procedureTemplateField: getProcedureTemplateField(procedureRun, ProcessClientOrigin.RECIPES),
  });
}
